import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { CoreService } from "src/app/services/core.service";
import { MatDialog } from "@angular/material/dialog";
import { navItems } from "../../vertical/sidebar/sidebar-data";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { TablerIconsModule } from "angular-tabler-icons";
import { MaterialModule } from "src/app/material.module";
import { BrandingComponent } from "../../vertical/sidebar/branding.component";
import { AppSettings } from "src/app/config";
import { FormsModule } from "@angular/forms";
import { SessionService } from "src/app/services/session.service";

@Component({
  selector: "app-horizontal-header",
  imports: [RouterModule, TablerIconsModule, MaterialModule, BrandingComponent],
  templateUrl: "./header.component.html",
})
export class AppHorizontalHeaderComponent implements OnInit, OnDestroy, OnDestroy{
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  @Output() optionsChange = new EventEmitter<AppSettings>();

  private langSubscription?: Subscription;

  public selectedLanguage: any = {
    language: "English",
    code: "en",
    type: "US",
    icon: "/assets/images/flag/icon-flag-en.svg",
  };

  public languages: any[] = [
    {
      language: "English",
      code: "en",
      type: "US",
      icon: "/assets/images/flag/icon-flag-en.svg",
    },
    {
      language: "Español",
      code: "es",
      icon: "/assets/images/flag/icon-flag-es.svg",
    },
  ];
  options = this.settings.getOptions();

  constructor(
    private settings: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private sessionService: SessionService,
  ) {
    translate.setDefaultLang("en");
  }

  ngOnInit(): void {
    const defaultLang = this.settings.getLanguage();
    const selected = this.languages.find((lang) => lang.code === defaultLang);
    if (selected) {
      this.selectedLanguage = selected;
    }

    this.langSubscription = this.translate.onLangChange.subscribe((event) => {
      const selectedLang = this.languages.find(
        (lang) => lang.code === event.lang,
      );
      if (selectedLang) {
        this.selectedLanguage = selectedLang;
      }
    });
  }

  ngOnDestroy(): void {
    this.langSubscription?.unsubscribe();
  
  }

  async logOut() {
    await this.sessionService.signOutUser();
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {});
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.settings.setLanguage(lang.code);
    this.selectedLanguage = lang;
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }
}

@Component({
  selector: "app-search-dialog",
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    TranslateModule,
  ],
  templateUrl: "search-dialog.component.html",
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = "";
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
